"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M8.957 19.002h6.086v-6.087H8.957v6.087ZM20.313 0c.272 0 .471.168.512.421l.008.099v7.707l3.074 3.005c.074.148.09.295.092.43l.001.1-.014.055a.555.555 0 0 1-.414.3l-.092.007h-2.647v11.357c0 .271-.17.47-.422.511l-.098.008H3.686a.492.492 0 0 1-.511-.42l-.008-.099V12.124H.519a.563.563 0 0 1-.46-.23l-.046-.077L0 11.762c0-.129 0-.272.047-.42l.045-.11.023-.032L10.724.512a1.75 1.75 0 0 1 2.347-.114l.125.113 2.638 2.639V.52c0-.273.17-.472.422-.512L16.355 0h3.958Zm-.52 1.039h-2.919v3.36a.51.51 0 0 1-.281.462l-.097.044c-.134.095-.369.028-.498-.062l-.048-.039-3.485-3.564a.516.516 0 0 0-.388-.199.754.754 0 0 0-.453.125l-.091.075-9.767 9.844h1.92c.272 0 .471.168.512.42l.008.099v11.357h15.587V11.604c0-.272.17-.47.422-.511l.098-.008h.124v.079h1.794l-2.358-2.359v-.051l-.006-.032-.028-.087c-.015-.047-.03-.093-.04-.136l-.006-.062V1.039Zm-4.23 10.837c.271 0 .47.17.51.422l.008.098v7.125c0 .273-.168.471-.42.512l-.098.008H8.436a.493.493 0 0 1-.512-.421l-.008-.099v-7.125c0-.272.17-.471.422-.512l.099-.008h7.126Z",
    clipRule: "evenodd"
  })]
});